// extracted by mini-css-extract-plugin
module.exports = {"root":"Map_root__36Ovi","mapRoot":"Map_mapRoot__2PxjX"};